<template>
    <section  class="bg-primary "  id="game">
        <div class="container">
            <h2 class="my-3 text-capitalize font-weight-bold title">game</h2>
              <div class="row height-40 align-items-top">
                 <div v-for="(item, index) in items" :key="index" class="col-sm-2 mb-3 text-center">
                    <img :src="item.image" :alt="item.name" class="img-fluid rounded" style="max-height:300px" >
                    <h5 class="my-3 text-capitalize font-weight-bold">{{item.name}}</h5>
                    <p class="text-secondary" v-html="item.description"></p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    data () {
        return {
            items: [{image: 'https://buffimgs.plaync.com/buff/contents/1/1000043/cover_9489310ce784885d9ea5b0e7d6a3f957ddfd94d61cb4e54c45b9681b23b40607.jpg' , name: '일곱 개의 대죄', description: '일찍이 왕국에 반역을 꾀했다고 여겨지는 7명의 전설의 역적 <일곱 개의 대죄>. '},
            {image: 'https://buffimgs.plaync.com/buff/contents/2/1000708/cover_eb1c485dd0f944c97acdc98dca275d9a4b9106f0a1871189e4c1cb35edbb3b74.jpg' ,  name: '각성능력자 ', description: '전생에 잘 나가던 검사, 중수부장 출신 차기 서울지검장 정용두. 정치비자금 x파일을 얻어 암행어사가 되기로 결심했다'},
            {image: 'https://buffimgs.plaync.com/buff/contents/1/1000155/cover_bd88c541ddb87a1636554d383e78f417e84abce88f7253d97487640de37d2f96.jpg' ,  name: '내가 인기 있어서 어쩌자는 거야', description: '전생에 잘 나가던 검사, 중수부장 출신 차기 서울지검장 정용두. 정치비자금 x파일을 얻어 암행어사가 되기로 결심했다'},
            {image: 'https://buffimgs.plaync.com/buff/contents/2/1000719/cover_e68e99f24efd8b807a953674a6736b54d7d4c3b99ba240896666073413bc3e52.jpg' ,  name: '일곱 개의 대죄', description: '<몬스터>, <마스터 키튼>, <빌리배트>의 스토리 작가 \'나가사키 타카시\'와 혜성처럼 등장한 신예 \'이상철\'의 작품으로 학산코믹스 앱에서 최초로 디지털 공개되었다. '},
            {image: 'https://buffimgs.plaync.com/buff/contents/1/1000053/cover_8a479b2d28c493ef7895dba31c0012708da48de459cdb0c64a5d3ba254d46bbf.jpg' ,  name: '일곱 개의 대죄', description: '<몬스터>, <마스터 키튼>, <빌리배트>의 스토리 작가 \'나가사키 타카시\'와 혜성처럼 등장한 신예 \'이상철\'의 작품으로 학산코믹스 앱에서 최초로 디지털 공개되었다. '}
            ]
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Game.vue